import { Guid } from "@/Common/Models/Guid";

class Service {
    public Id: string;
    public DefId: Guid;
    public IsInactive: boolean;
    public EmployeeId: string;
}

export { Service };
